'use strict';

import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  if ($('.field--report-custom-timeframe').length) {
    $('.field--report-custom-timeframe').datepicker();
  }

  $(document).on('change', '.radio--report-type', (e) => {
    const reportType = $(e.target).val();
    $('.report-config-form__status').toggleClass('hide', reportType === 'package_sales_report');
    $('.report-config-form__invoice-based-on').toggleClass(
      'hide',
      reportType === 'package_sales_report'
    );
  });

  $(document).on('change', '.field--report-timeframe', (e) => {
    $('.report-config-form__custom-timeframe').toggleClass('hide', $(e.target).val() !== 'custom');
  });

  $(document).on('change', '.checkbox--report-statuses', (e) => {
    if ($(e.target).is(':checked')) {
      if ($(e.target).val() === 'all') {
        $('.checkbox--report-statuses:not(#report_statuses_all)').prop('checked', false);
      } else {
        $('.checkbox--report-statuses#report_statuses_all').prop('checked', false);
      }
    }
  });

  $(document).on('change', '.radio--invoice-based-on', (e) => {
    const invoiceBasedOn = $(e.target).val();
    $('.checkbox__label--report-status-without-paid-at').toggleClass(
      'checkbox__label--disabled',
      invoiceBasedOn === 'paid_at'
    );
  });
});
